import { FC } from 'react'
import { Page } from '../../../components/Page'
import { ValidationResults } from './ValidationResults'

export const ValidationResultsPage: FC = () => {
  return (
    <Page title={'Address Change Scheduler'}>
      <ValidationResults title={'Schedule An Address Change'} />
    </Page>
  )
}
